import {createPrimitiveAtom} from '@reatom/core/primitives'

export const pageLoadingAtom =
  createPrimitiveAtom<DefaultLoadingState>('loading')
